<template>
    <div class="py-8 sm:py-12">
        <section class="mx-auto max-w-3xl text-center" aria-labelledby="unavailable-title">
            <h1 id="unavailable-title" class="text-3xl font-bold text-gray-900 sm:text-4xl dark:text-txt-headings">
                Ponuka nie je aktuálne dostupná
            </h1>
            <p class="mt-4 text-lg text-gray-600 dark:text-txt-body">
                Ponuka už mohla byť ukončená alebo ju autor prestal zverejňovať. Skús si pozrieť ďalšie aktuálne
                možnosti.
            </p>
            <div class="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
                <CButton :to="destination.path" :aria-label="destination.label" variant="primary" @click="trackBrowse">
                    {{ destination.label }}
                </CButton>
                <CButton v-if="destination.path !== '/'" to="/" aria-label="Domov" variant="primary-150">
                    Domov
                </CButton>
            </div>
        </section>

        <RecommendedItems
            v-if="destination.collection"
            :key="`${destination.collection}-${sourceId}`"
            :id="sourceId"
            :collection="destination.collection"
            :max-items-to-show="4"
            class="mt-10"
            eager
            compact
            no-separator
            @item-click="trackRecommendation"
            @loaded="trackRecommendationsLoaded"
        >
            {{ destination.heading }}
        </RecommendedItems>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'
import RecommendedItems from '@/components/common/RecommendedItems.vue'
import { useCheese } from '@/composables/useCheese'
import { getUnavailableDestination } from '@/utils/unavailableOffer'

const route = useRoute()
const { track } = useCheese()
const destination = computed(() => getUnavailableDestination(route.query.type))
const sourceId = computed(() => {
    const id = route.query.id
    return typeof id === 'string' && /^[\w-]{1,200}$/.test(id) ? id : ''
})
const properties = () => ({ offer_type: destination.value.collection || 'unknown', offer_id: sourceId.value })
function trackBrowse() {
    track('unavailable_offer_browse_clicked', properties())
}
function trackRecommendation(item: { id: string }) {
    track('unavailable_offer_recommendation_clicked', { ...properties(), recommended_id: item.id })
}
function trackRecommendationsLoaded(count: number) {
    track('unavailable_offer_recommendations_loaded', { ...properties(), count })
}
onMounted(() => track('unavailable_offer_viewed', properties()))
useHead({
    title: 'Ponuka nie je aktuálne dostupná | GROWNi',
    meta: [{ name: 'robots', content: 'noindex, follow' }]
})
</script>
